import React, { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTheme } from '@/context/ThemeContext'
import AdminSidebar from '@/features/admin/components/AdminSidebar'
import WorkspaceTable from '@/features/admin/components/WorkspaceTable'
import { useAdminWorkspaces } from '@/features/admin/hooks/useAdminWorkspaces'

const AdminWorkspacesPage: React.FC = () => {
  const { currentTheme } = useTheme()
  const [searchParams] = useSearchParams()
  const initialWorkspaceId = searchParams.get('ws') ?? undefined
  const { data, loading, error, page, setPage, updateWorkspace, assignPlan } = useAdminWorkspaces(1, 20)

  const handleUpdateWorkspace = useCallback(
    async (id: string, payload: Partial<{ isActive: boolean }>) => {
      await updateWorkspace(id, payload)
    },
    [updateWorkspace],
  )

  const handleAssignPlan = useCallback(
    async (id: string, planId: string | null) => {
      await assignPlan(id, planId)
    },
    [assignPlan],
  )

  return (
    <div className="min-h-screen" style={{ backgroundColor: currentTheme.primary }}>
      <AdminSidebar />

      <main className="lg:pl-56 min-h-screen">
        <div className="px-4 pt-16 pb-8 sm:px-6 lg:px-8 lg:pt-8">
          <div className="mb-8">
            <h1 className="text-2xl font-bold" style={{ color: currentTheme.text }}>
              Workspaces
            </h1>
            <p className="mt-1 text-sm" style={{ color: currentTheme.secondrytext }}>
              Manage platform workspaces
            </p>
          </div>

          {error && (
            <div
              className="mb-6 rounded-2xl px-5 py-4 text-sm"
              style={{
                backgroundColor: currentTheme.errorBackground,
                color: currentTheme.errorText,
                border: `1px solid ${currentTheme.border}`,
              }}
            >
              {error}
            </div>
          )}

          <WorkspaceTable
            workspaces={data?.data ?? []}
            total={data?.total ?? 0}
            page={page}
            limit={20}
            loading={loading}
            onPageChange={setPage}
            onUpdateWorkspace={handleUpdateWorkspace}
            onAssignPlan={handleAssignPlan}
            {...(initialWorkspaceId ? { initialWorkspaceId } : {})}
          />
        </div>
      </main>
    </div>
  )
}

export default AdminWorkspacesPage
